export const STATUS = {
  open: { label: "Ouverte", cls: "bg-white text-zinc-700 border-zinc-300" },
  quoted: { label: "Devis reçus", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  paid: { label: "Séquestré", cls: "bg-[#FF4D00] text-white border-[#FF4D00]" },
  in_progress: { label: "En cours", cls: "bg-blue-50 text-blue-700 border-blue-300" },
  validated: { label: "Validée", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  completed: { label: "Terminée", cls: "bg-emerald-600 text-white border-emerald-700" },
  cancelled: { label: "Annulée", cls: "bg-zinc-200 text-zinc-700 border-zinc-400" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || { label: status, cls: "bg-white text-zinc-700 border-zinc-300" };
  return <span className={`badge-pill ${s.cls}`}>{s.label}</span>;
}

export function fmtEUR(n) {
  if (n == null) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
}
